<!-- =========================================================================================
	File Name: ChatLog.vue
	Description: Chat Application - Log of chat
	----------------------------------------------------------------------------------------
	Item Name: 
	Version: 1.1
	Author: Prasyde
	Author URL: www.prasyde.com
========================================================================================== -->
<template>
	<div id="component-chat-log" class="m-8" v-if="chatData">
		<div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">
			<vs-divider v-if="index===0">{{msg.fecha.substring(0, 11)}}</vs-divider>
			<vs-divider v-else-if="!isSameDay(msg.fechaSinFormato, chatData[index-1].fechaSinFormato)">{{msg.fecha.substring(0,11)}}</vs-divider>
			<div class="flex items-start" :class="[{'flex-row-reverse' : msg.mensajePropio}]">
				<div class="flex flex-col">
					<p :class="msg.mensajePropio ? 'self-end':'self-start'">{{msg.fecha.substring(11)}}</p>
					<div class="msg relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-md flex flex-col" :class="{'bg-primary-gradient text-white': msg.mensajePropio, 'border border-solid border-grey-light bg-white': !msg.mensajePropio}">
							<p>{{ msg.mensaje }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default{
	props: {
		chatMsgs:{
			type:Array,
			required:true
		}
	},
	computed: {
		chatData() {
			return this.chatMsgs;
		}
	},
	methods: {
		isSameDay(time_to, time_from) {
			return moment(time_to).isSame(time_from);
		}
	}
}
</script>